import { useState } from 'react';
import { hrApi } from '@/api';
import { EmployeeSelect } from '@/components/selects';
import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { showApiError } from '@/utils/apiError';
import { notify } from '@/core/toast/notify';

export function HrOnboardingPage() {
  const [employeeId, setEmployeeId] = useState('');
  const [managerId, setManagerId] = useState('');
  const [exitEmployeeId, setExitEmployeeId] = useState('');
  const [exitReason, setExitReason] = useState('');

  const start = async () => {
    try {
      await hrApi.startOnboarding(Number(employeeId), managerId ? Number(managerId) : undefined);
      notify.success('Onboarding started');
    } catch (err) {
      showApiError(err, 'Onboarding failed');
    }
  };

  const exit = async () => {
    try {
      await hrApi.initiateExit({ employeeId: Number(exitEmployeeId), exitType: 'RESIGNATION', lastWorkingDay: undefined });
      notify.success('Exit initiated');
    } catch (err) {
      showApiError(err, 'Exit initiation failed');
    }
  };

  const finalize = async () => {
    try {
      await hrApi.finalizeExit(Number(exitEmployeeId));
      notify.success('Exit finalized');
    } catch (err) {
      showApiError(err, 'Exit finalize failed');
    }
  };

  return (
    <div>
      <PageHeader title="Onboarding & exit" description="Preboarding tasks and separation workflow" breadcrumbs={[{ label: 'HR', to: '/hr' }, { label: 'Lifecycle' }]} />
      <div className="grid gap-4 lg:grid-cols-2">
        <section className="card space-y-3 p-4">
          <h3 className="font-semibold">Start onboarding</h3>
          <EmployeeSelect value={employeeId} onChange={setEmployeeId} />
          <EmployeeSelect label="Manager (optional)" value={managerId} onChange={setManagerId} />
          <Button onClick={() => void start()}>Start onboarding</Button>
        </section>
        <section className="card space-y-3 p-4">
          <h3 className="font-semibold">Exit / separation</h3>
          <EmployeeSelect value={exitEmployeeId} onChange={setExitEmployeeId} />
          <Input label="Reason" value={exitReason} onChange={(e) => setExitReason(e.target.value)} />
          <div className="flex gap-2">
            <Button variant="secondary" onClick={() => void exit()}>Initiate exit</Button>
            <Button onClick={() => void finalize()}>Finalize exit</Button>
          </div>
        </section>
      </div>
    </div>
  );
}
